import { Shapes } from '@/components/public/Visualisations/types'
import { Axes, AxisTick } from '@/components/public/Visualisations/XYBubbles/types'
import { Coordinate2D, Path } from '@/types'
import Konva from 'konva'

export class AxisTickText extends Konva.Text implements Shapes.Shape {
  static fontSize = 38
  static fontFamily = 'Segoe UI'
  static maximumWidth = 250
  private _axis: Axes

  key: string = 'axis-tick-text'
  path: Path = new Path({})
  center: Coordinate2D = this.position()
  capabilities: Shapes.Capability[] = []
  refresh: () => void = () => {}

  constructor(axis: Axes) {
    super({
      stroke: '#6C757D',
      fontSize: AxisTickText.fontSize,
      fontFamily: AxisTickText.fontFamily,
      listening: false,
      ellipsis: true,
    })

    if (axis === Axes.y) {
      this.height(this.fontSize())
      this.wrap('none')
    }

    this._axis = axis
  }

  update(props: AxisTick) {
    this.text(props.label)
    this.width(Math.min(this.width(), AxisTickText.maximumWidth))

    this.position({
      x: props.position.x - this.xOffset,
      y: props.position.y - this.yOffset,
    })
    this.moveToTop()
  }

  private get yOffset() {
    const additionalOffset = this._axis === Axes.x ? -50 : 0
    return this.height() / 2 + additionalOffset
  }

  private get xOffset() {
    return this._axis === Axes.x ? this.width() / 2 : this.width()
  }
}
